import { useEffect, useState } from 'react'
import { Link } from 'react-router'
import { client, urlFor } from '../lib/sanityClient'
import styles from './BlogSection.module.css'
import { useLocation, useNavigate } from "react-router";

const categoryLabels = {
  'safari-tips': 'Safari Tips',
  'wildlife': 'Wildlife',
  'tour-operations': 'Tour Operations',
  'technology': 'Technology',
  'news': 'News',
}

const categoryStyle = {
  'safari-tips': 'badgeSafariTips',
  'wildlife': 'badgeWildlife',
  'tour-operations': 'badgeTourOperations',
  'technology': 'badgeTechnology',
  'news': 'badgeNews',
}

const BlogCard = ({ post }) => {
  return (
    <article className={styles.card}>
      {/* <div className={`${styles.thumb} ${!post.coverImage ? styles.thumbPlaceholder : ''}`}>
        {post.coverImage ? (
          <img
            src={urlFor(post.coverImage).width(600).height(340).fit('crop').url()}
            alt={post.title}
            className={styles.thumbImg}
          />
        ) : (
          <span className={styles.thumbLogo}>Twigaa.ai</span>
        )}
      </div> */}

      <div className={styles.body}>
        {/* {post.category && (
          <span className={`${styles.badge} ${styles[categoryStyle[post.category] || 'badgeTechnology']}`}>
            {categoryLabels[post.category] || post.category}
          </span>
        )} */}

        <h3 className={styles.title}>{post.title}</h3>

        {post.excerpt && (
          <p className={styles.excerpt}>
            {post.excerpt.length > 120 ? post.excerpt.slice(0, 120) + '…' : post.excerpt}
          </p>
        )}

        <div className={styles.footer}>
          <div className={styles.meta}>
            {/* {post.author && <strong className={styles.metaAuthor}>{post.author}</strong>} */}
            {post.publishedAt && (
              <span className={styles.metaDate}>
                {new Date(post.publishedAt).toLocaleDateString('en-US', {
                  month: 'short', day: 'numeric', year: 'numeric',
                })}
              </span>
            )}
          </div>
          <Link to={`/blog/${post.slug.current}`} className={styles.readBtn}>
            Read More
          </Link>
        </div>
      </div>
    </article>
  )
}

const BlogSection = () => {
  const [posts, setPosts] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate();

  useEffect(() => {
    client
      .fetch(`*[_type == "post"] | order(publishedAt desc) [0...6] {
        _id, title, slug, excerpt, publishedAt, coverImage, author, category
      }`)
      .then(data => { setPosts(data); setLoading(false) })
      .catch(() => setLoading(false))
  }, [])

  const scrollToTop = (value) => {
        navigate('/'+value);
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: for smooth scroll animation
        });
  };
  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.heading}>From Our Blog</h2>
        <span className={styles.divider} />
        <p className={styles.subheading}>
          Insights on safari planning, wildlife, and tour operations
        </p>
      </div>

      {loading ? (
        <div className={styles.loaderWrap}>
          <div className={styles.spinner} role="status">
            <span className={styles.srOnly}>Loading...</span>
          </div>
        </div>
      ) : posts.length === 0 ? (
        <p className={styles.emptyMsg}>No posts published yet. Check back soon.</p>
      ) : (
        <div className={styles.grid}>
          {posts.map(post => (
            <BlogCard key={post._id} post={post} />
          ))}
        </div>
      )}

      <div className={styles.viewAllWrap}>
        <a onClick={()=> scrollToTop('blog')} className={styles.viewAllBtn} style={{cursor:'pointer'}}>View All Posts →</a>
      </div>
    </section>
  )
}

export default BlogSection
